import { render, staticRenderFns } from "./MonthlyChart.vue?vue&type=template&id=4b487bb5&"
import script from "./MonthlyChart.vue?vue&type=script&lang=js&"
export * from "./MonthlyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports